<template>
  <transition name="nav">
    <div id="nav" v-if="show">
      <div class="nav__wrapper">
        <nav-item v-for="(project, key) in projects" :key="key" :data="project" :active="project.slug == active.slug ? true : false" :index="++key"/>
        <lines/>
      </div>
    </div>
  </transition>
</template>

<script>

import projects from '@/json/projects'
import NavItem from '@/components/NavItem'
import Lines from '@/components/Lines'

import store from '@/store'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'navList',
  components:{
    NavItem,
    Lines,
  },
  data() {
    return{
      projects,
    }
  },
  computed: {
    ...mapGetters({
      show: 'show'
    }),
    ...mapState({
      active: state => state.projects.project,
    })
  }
}
</script>

<style lang="scss">
#nav{
  position: fixed;
  z-index: 150;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--black);
  pointer-events: none;
  transform: translateZ(0);
  will-change: transform;
  .lines{
    opacity: .2;
    z-index: 100;
  }
}

.nav-enter-active, .nav-leave-active{
  transition: clip-path .4s var(--easing);
  clip-path: circle(100% at 120px 50%);
}

.nav-enter, .nav-leave-to{
  clip-path: circle(0% at 120px 50%);
}

</style>



// WEBPACK FOOTER //
// src/components/Nav.vue